import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/abi/skumgmt'
import pathMap from 'src/paths/pathMap'
import React from 'react'

class AbiSKUMgmtRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_SKU_MGMT_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ABI_SKU_MGMT_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ABI_SKU_MGMT_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ABI_SKU_MGMT_DETAILS_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ABI_SKU_MGMT_VIEW,
        component: ViewPage
      },
    ]
  }
}

export default AbiSKUMgmtRoute
